import axios from "axios";
import firebase from "firebase";
import { logger } from "../../constant/winston";

export const setFirebaseConfig = async () => {
  try {
      const resp = await axios.get("/firebase.config.json");
      firebase.initializeApp(resp.data);
  } catch (err) {
      logger.error(err);
  }
}